"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerchantIPNKind = void 0;
var MerchantIPNKind;
(function (MerchantIPNKind) {
    MerchantIPNKind["Replenish"] = "Replenish";
    MerchantIPNKind["Withdraw"] = "Withdraw";
    MerchantIPNKind["Invoice"] = "Invoice";
    MerchantIPNKind["WithdrawBatch"] = "WithdrawBatch";
    MerchantIPNKind["CryptoExchangeWithdraw"] = "CryptoExchangeWithdraw";
    MerchantIPNKind["FiatExchangeWithdraw"] = "FiatExchangeWithdraw";
    MerchantIPNKind["Exchange"] = "Exchange";
    MerchantIPNKind["CryptoInvoice"] = "CryptoInvoice";
})(MerchantIPNKind = exports.MerchantIPNKind || (exports.MerchantIPNKind = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVyY2hhbnRJUE5LaW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21lcmNoYW50LWlwbi9NZXJjaGFudElQTktpbmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxlQVNYO0FBVEQsV0FBWSxlQUFlO0lBQ3pCLDBDQUF1QixDQUFBO0lBQ3ZCLHdDQUFxQixDQUFBO0lBQ3JCLHNDQUFtQixDQUFBO0lBQ25CLGtEQUErQixDQUFBO0lBQy9CLG9FQUFpRCxDQUFBO0lBQ2pELGdFQUE2QyxDQUFBO0lBQzdDLHdDQUFxQixDQUFBO0lBQ3JCLGtEQUErQixDQUFBO0FBQ2pDLENBQUMsRUFUVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQVMxQiJ9